var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomerMcs',{attrs:{"company-id":_vm.companyId,"agent-id":_vm.userId},on:{"leave":_vm.leave,"logout":_vm.logout}})
}
var staticRenderFns = []

export { render, staticRenderFns }